import { Outlet, RouteObject } from "react-router-dom";
import { lazyImport } from "@/lib/utils";
import { Toaster } from "@/providers/toaster";
import { AuthLayout } from "@/components/auth";
import { RequireUser } from "@/providers/user";
import {
  // About,
  Blog,
  BlogDetails,
  Categories,
  Contact,
  Faq,
  ForgotPassword,
  LandingPage,
  PrivacyPolicy,
  ProductDetails,
  ResetPassword,
  ReturnPolicy,
  ShippingPolicy,
  Shop,
  SignUp,
  Terms,
} from "@/pages/auth";
import { Navbar } from "@/components/navbar";
import { Footer } from "@/components/views";
import { VerifyEmail } from "@/pages/auth/verify-email";
import ScrollToTop from "@/ScrollToTop";

const { Login } = lazyImport(() => import("@/pages/auth"), "Login");

export const authRoutes: RouteObject[] = [
  // Authentication routes (login, signup, etc.)
  {
    element: (
      <AuthLayout>
        <Outlet />
        <Toaster />
      </AuthLayout>
    ),
    children: [
      { path: "/login", element: <Login /> },
      { path: "/signup", element: <SignUp /> },
      { path: "/forgot-password", element: <ForgotPassword /> },
      { path: "/reset-password", element: <ResetPassword /> },
      { path: "/verify-email", element: <VerifyEmail /> },
    ],
  },

  // Public routes (no authentication required)
  {
    element: (
      <RequireUser isOptional>
        <ScrollToTop />
        <Navbar />
        <Outlet />
        <Footer />
      </RequireUser>
    ),
    children: [
      { path: "/", element: <LandingPage /> },
      // { path: "/about", element: <About /> },
      { path: "/faq", element: <Faq /> },
      { path: "/shop", element: <Shop /> },
      { path: "/shipping-policy", element: <ShippingPolicy /> },
      { path: "/return-policy", element: <ReturnPolicy /> },
      { path: "/contact", element: <Contact /> },
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      { path: "/terms-of-service", element: <Terms /> },
      { path: "/shop/category/:categoryId", element: <Shop /> },
      { path: "/product/:productSlug", element: <ProductDetails /> },
      { path: "/blog", element: <Blog /> },
      { path: "/blog/:slug", element: <BlogDetails /> },
      { path: "/categories", element: <Categories /> },
      { path: "/categories/:categoryId", element: <Categories /> },
      { path: "/categories/:categoryId/:subcategoryId", element: <Categories /> },
    ],
  },
];
